export const BREADCRUMBS_STUDIO_EXPERIMENT = 'specs.studio.breadcrumbsSection';
